export class ModuleCache {
    enabled: Array<string>;
}
